export const IsSmallScreenSize = (width: number): boolean => width <= 768;

export const getMaxVisibleColumns = (screenWidth: number): number => {
  const showMobileNav = IsSmallScreenSize(screenWidth);

  if (showMobileNav) {
    if (screenWidth > 750) {
      return 6;
    } else if (screenWidth > 650) {
      return 5;
    } else if (screenWidth > 540) {
      return 4;
    } else if (screenWidth > 440) {
      return 3;
    } else if (screenWidth > 300) {
      return 2;
    } else {
      return 1;
    }
  }

  if (screenWidth > 1400) {
    return 10;
  } else if (screenWidth > 1300) {
    return 9;
  } else if (screenWidth > 1200) {
    return 8;
  } else if (screenWidth > 1100) {
    return 7;
  } else if (screenWidth > 980) {
    return 6;
  } else if (screenWidth > 880) {
    return 5;
  }
  return 4;
};
